import { connect } from 'react-redux'
import ClerksView from '../components/ClerksView'
import { loadClerksDevices, updateDevice, createClerk,
  serverError, openClerkModal, openDeviceModal,
  createDevice, openEditDeviceModal, setEditDeviceInfo,
  changeActiveHistoryPage, showOnlyActiveDevices,
  openClerkChangePasswordModal, openClerkEditModal,
  changePassword, editUser, showSuccessResponse } from '../modules/clerks';
import { USER_ROLES } from "../../../constants";

const mapDispatchToProps = {
  loadClerksDevices,
  updateDevice,
  createClerk,
  createDevice,
  changePassword,
  editUser,
  dispatchSuccessResponse: showSuccessResponse,
  dispatchServerError: serverError,
  setOpenClerkModal: openClerkModal,
  setOpenDeviceModal: openDeviceModal,
  setOpenEditDeviceModal: openEditDeviceModal,
  setOpenClerkChangePasswordModal: openClerkChangePasswordModal,
  setOpenClerkEditModal: openClerkEditModal,
  setEditDeviceInfo,
  changeActiveHistoryPage,
  showOnlyActiveDevices
};

const mapStateToProps = (state) => {
    const activePage = state.clerks.activePage;
    const itemsPerPage = 5;

    const onlyActiveDevices = state.clerks.onlyActiveDevices;
    let clerkDevices = _.sortBy(state.clerks.clerkDevices, (d) => -d.weight);

    if (onlyActiveDevices) {
      clerkDevices = _.filter(clerkDevices, {enabled: true})
    }

    const clerks = _.sortBy(state.clerks.clerks, (d) => -d.id);

    const totalPages = Math.ceil((clerkDevices ? clerkDevices.length : 0) / itemsPerPage);

    return {
      current_user_id: state.user.id,
      clerkDevices: clerkDevices && clerkDevices.slice((itemsPerPage * (activePage - 1)), itemsPerPage * activePage),
      employees: _.sortBy(_.filter(clerks, (c) => c.role === USER_ROLES.STORE_CLERK || c.id === state.user.id), (user) => user.role !== USER_ROLES.STORE_OWNER),
      clerks: _.filter(clerks, (c) => c.role === USER_ROLES.STORE_CLERK),
      owners: _.filter(clerks, (c) => c.role === USER_ROLES.STORE_OWNER),
      serverError: state.clerks.serverError,
      errorMessages: state.clerks.errorMessages,
      showSuccessResponse: state.clerks.showSuccessResponse,
      loading: state.clerks.setLoading,
      deviceChanged: state.clerks.deviceChanged,
      activePage,
      totalPages,

      openClerkModal: state.clerks.openClerkModal,
      openDeviceModal: state.clerks.openDeviceModal,
      openEditDeviceModal: state.clerks.openEditDeviceModal,
      openClerkEditModal: state.clerks.openClerkEditModal,
      openClerkChangePasswordModal: state.clerks.openClerkChangePasswordModal
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClerksView)



// WEBPACK FOOTER //
// ./src/components/Clerks/containers/ClerksViewContainer.js